import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class BackgroundTasksGrid extends BaseComponent {
	
	static get properties() {
		return {	
			nodeId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		var taskGrid = this;
		setTimeout(function(){
			taskGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var taskGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',					
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},								
				{
					tag: 'dl-action-button',											
					itemid: 'cancel',
					theme: 'error primary',
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:close', ' Cancel')
					],
					listeners: {
						click: function() {
							actionCancelTask(grid.selectedItems[0]);
						}
					}
				}
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'taskName',
					header: 'Name',
					width: '9em'
				},
				{						
					path: 'details',
					header: 'Details',
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'submitedDts',
					header: 'Submit Date',
					width: '9em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.submitedDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				},
				{
					path: 'completedDts',
					header: 'Completed Date',
					width: '9em',
					renderer: function(root, column, rowData) {
						if (rowData.item.completedDts) {
							var date = TimeUtil.parseDate(rowData.item.completedDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);
						}
					}
					
				},
				{
					path: 'status',
					header: 'Status',
					'text-align': 'center',
					width: '9em'										
				},
				{
					path: 'createUser',
					header: 'Create User',
					width: '9em'
				},
				{
					path: 'progress',
					header: 'Progress',
					width: '9em',
					renderer: function(root, column, rowData) {
						if (rowData.item.status === 'WORKING') {
							if (rowData.item.progress === -1) {
								root.innerHTML = '<vaadin-progress-bar indeterminate value="0"></vaadin-progress-bar>';
							} else {
								root.innerHTML = rowData.item.progress + '%<br><vaadin-progress-bar value="' + (rowData.item.progress/100) + '"></vaadin-progress-bar>';
							}
						} else {
							root.innerHTML = '<vaadin-progress-bar value="100"></vaadin-progress-bar>';
						}
					}
				},
				{
					path: 'error',
					header: 'Error',
					width: '9em',
					'flex-grow': '1'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'cancel').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'cancel').disabled = true;
					}	
				}
			}
		});
		
		var footer = ElementUtil.create({
			tag: 'table',
			slot: 'footer',
			style: 'width: 100%; border: 1px solid grey;'
		});
		
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer
			]
		});		
		taskGrid.append(flexLayout);		
		
		
		var updateFooterStatus = function(status) {			
			var stats = `
				<tr style="background-color: #818181; color: white; font-weight: bold; text-align: center;">
					<th>Active</th>
					<th>Completed</th>
					<th>Total</th>					
				</tr>
				<tr style="text-align: center;">
					<td>${status.activeCount}</td>
					<td>${status.completedCount}</td>
					<td>${status.totalTaskCount}</td>
				</tr>
				<tr style="background-color: #818181; color: white; font-weight: bold; text-align: center;">
					<th>Queued</th>
					<th>Current Size</th>
					<th>Max Pool Size</th>					
				</tr>					
				<tr style="text-align: center;">
					<td>${status.queuedCount}</td>
					<td>${status.threadPoolSize}</td>
					<td>${status.maxPoolSize}</td>
				</tr>
				<tr style="background-color: #818181; color: white; font-weight: bold; text-align: center;">
					<th>Work Pool Queued</th>
					<th>Work Pool Total Tasks Scheduled</th>					
				</tr>					
				<tr style="text-align: center;">
					<td>${status.workPoolQueuedCount}</td>
					<td>${status.workPoolTotalTaskCount}</td>					
				</tr>			
			`;
			footer.innerHTML = stats;
		};		
		
		var actionRefresh = function() {
			var loadMask = taskGrid.showLoading();	
			Service.getNodeService().getTasksStatus(taskGrid.nodeId).then(function(status){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = status.tasks;	
				updateFooterStatus(status);
			});					
			
		};
		actionRefresh();		
		
		var actionCancelTask = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Cancel task',
				message: 'Are you sure you want to cancel ' + record.taskName + '? <br> <br> (This will attempt to cancel the running task; it may be unable to in some cases.<br>This will remove non-running tasks.)',				
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = taskGrid.showLoading('Canceling ' + record.taskName + '...');
							Service.getNodeService().cancelTask(taskGrid.nodeId, record.taskId).then(function(results){
								loadMask.remove();
								
								if (results.success) {
									window.DL.MessageUtil.showToast('Success', 'Successful attempted to cancel task: ' + record.taskName, {									
										theme: 'success'
									});
								} else {
									window.DL.MessageUtil.showToastError('Unable to cancel task.', 'Failed');
								}
								actionRefresh();
							}, function(){
								loadMask.remove();
							});							
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
		
	}

};

customElements.define('dl-backgroundtasks-grid', BackgroundTasksGrid);
